<script lang="ts">
  import Card from "./SharePCP/Card.svelte";
  import Dialog from "./SharePCP/Dialog.svelte";
  import type { Snippet } from "svelte";

  const {
    shareUrl,
    addUrl,
    children,
  }: {
    shareUrl: string;
    addUrl?: string;
    children?: Snippet;
  } = $props();

  let dialog = $state<Dialog>();

  const onsubmit = (event: Event) => {
    event.preventDefault();
    dialog?.showModal();
  };
</script>

<form {onsubmit}>
  {#if children}
    {@render children()}
  {:else}
    <Card addUrl={addUrl!} />
  {/if}
</form>

<Dialog bind:this={dialog} {shareUrl} />
